import { render, staticRenderFns } from "./ClaimCheckbox.vue?vue&type=template&id=68a7bd74&"
import script from "./ClaimCheckbox.vue?vue&type=script&lang=js&"
export * from "./ClaimCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports